import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { lastValueFrom } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EnvService } from "./env.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private readonly httpClient = inject(HttpClient);
  private readonly oauthService = inject(OAuthService);
  private readonly router = inject(Router);
  private readonly envService = inject(EnvService);

  constructor() {
    this.configureOAuthService();
  }

  async configureOAuthService() {
    const authConfig = this.envService.getAuthCodeFlowConfig();
    this.oauthService.configure(authConfig);
    try {
      await this.oauthService.loadDiscoveryDocumentAndTryLogin();
      if (this.router["options"]["useHash"]) {
        this.router.navigate([window.location.hash.substring(2)]);
      }
    } catch (_error) {
      console.log("Unable to load authorization configuration.");
      console.log(_error);
    }
  }

  login() {
    this.oauthService.initLoginFlow();
  }

  isLoggedIn() {
    return this.oauthService.hasValidAccessToken();
  }

  async logout() {
    if (this.isLoggedIn()) {
      const headers = new HttpHeaders({
        Authorization: "Bearer " + this.getAccessToken(),
      });
      lastValueFrom(
        this.httpClient.post(this.envService.getLogoutUrl(), null, {
          headers: headers,
          withCredentials: false,
        })
      );
    }
    this.oauthService.logOut();
    this.router.navigate(["login"]);
  }

  getAccessToken(): string {
    return this.oauthService.getAccessToken();
  }
}
